import styled from 'styled-components';

import { Button } from 'shared/components/Button';
import { Modal } from 'shared/components/Modal';
import { t } from 'localization/utils/t';

const TP = 'checkout.components.Payment.RequirementsNotMetModal';

export const RequirementsNotMetModal = ({ children, onClose }) => {
  return (
    <RequirementsNotMetModal.Modal
      data-qa="requirements_not_met_modal"
      onClose={onClose}
      title={t(`${TP}.requirementsNotMetTitle`, 'Requirement Issue')}
    >
      <RequirementsNotMetModal.Body>{children}</RequirementsNotMetModal.Body>
      <RequirementsNotMetModal.Cta>
        <Button data-qa="requirements_not_met_modal_ok" inverted onClick={onClose}>
          {t(`${TP}.requirementsNotMetOk`, 'Okay')}
        </Button>
      </RequirementsNotMetModal.Cta>
    </RequirementsNotMetModal.Modal>
  );
};

RequirementsNotMetModal.Modal = styled(Modal)`
  max-width: 335px;
`;

RequirementsNotMetModal.Body = styled.p`
  margin: 8px 0 32px;
`;

RequirementsNotMetModal.Cta = styled.div`
  display: flex;
`;
